import { REQUEST_STATUS, RequestStatusLabel } from "../constants/status";

/**
 * Maps raw request status to display CSS class status.
 * - F (FAILED) → T (PROCESSING) — displays as "Processing"
 * - All others pass through unchanged
 */
export const getDisplayStatus = (status: string): string => {
  const statusDisplayMap: Record<string, string> = {
    [REQUEST_STATUS.FAILED]: REQUEST_STATUS.PROCESSING,
  };
  return statusDisplayMap[status] ?? status;
};

/**
 * Returns the i18n label key for a given request status.
 * Uses the RequestStatusLabel mapping from constants/status.ts.
 */
export const getDisplayLabel = (status: string): string => {
  return RequestStatusLabel[status as REQUEST_STATUS] ?? status;
};
